import { Action, createReducer, on } from '@ngrx/store';
import * as actions from './actions-selected-plan.actions';
import { IRate } from '@core/models/Rate/Rate.interface';
import { AppState } from '@store/app.reducer';

export enum StepsEnum {
  SELECTED_DAY = 'Cantidad de días',
  TICKET = 'Seleccioná entradas',
  MEAL_PLAN = 'Plan de comida',
}

export interface IActionsBtn extends AppState {
  current_step: StepsEnum;
  meal_play_by_selected_ticket: string[];
  allow_empty_ticket: boolean;
  selected_rate: IRate;
  ticket_selected: false;
  start_ticket: Date;
  loading: boolean;
}

export interface AppStateWithActions extends AppState {
  tickets: IActionsBtn;
}

const initialData = {
  current_step: StepsEnum.SELECTED_DAY,
  meal_play_by_selected_ticket: [],
  allow_empty_ticket: false,
  selected_rate: null,
  ticket_selected: false,
  start_ticket: null,
  loading: false,
};

const _actionsTicketDisney = createReducer(
  initialData,
  on(actions.changeStep, (state, { current_step }) => {
    return {
      ...state,
      current_step,
    };
  }),
  on(actions.mealPlanByTicket, (state, { meal_plan }) => {
    return {
      ...state,
      meal_play_by_selected_ticket: meal_plan,
    };
  }),
  on(actions.allowEmptyTicket, (state, { empty_ticket }) => {
    state.allow_empty_ticket = empty_ticket;
    return state;
  }),
  on(actions.selectedRate, (state, { selected_rate }) => {
    return {
      ...state,
      selected_rate: selected_rate,
    };
  }),
  on(actions.ticketAdded, (state, { ticket_selected }) => {
    return {
      ...state,
      ticket_selected: ticket_selected,
    };
  }),
  on(actions.startTicket, (state, { start_ticket }) => {
    return {
      ...state,
      start_ticket,
    };
  }),
  on(actions.loading, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.showLoader, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.hideLoader, (state) => {
    return {
      ...state,
      loading: false,
    };
  }),
);

export function ActionsTicketDisney(state: IActionsBtn, action: Action) {
  return _actionsTicketDisney(state, action);
}
